module.exports = __webpack_public_path__ + "assets/img/b1.65440837.png";